<!--
   본 소프트웨어는 관련 법률에 따라 보호되는 삼성의 지식재산 및 영업비밀 입니다. 본 소프트웨어를 권한 없이 사용하거나 삼성의 사전 서면 동의 없이 제3자에게 공개하는 행위는
   엄격히 금지되어 있으며 위반 시 귀하는 무단 사용 또는 비밀 유지 의무 위반에 대해 법적인 책임을 져야 합니다. This software is the intellectual
   property and confidential information of Samsung Electronics, Co., Ltd. (“Samsung”) protected by
   applicable laws. The unauthorized use or disclosure of the software to any third party without
   the prior written consent of Samsung is strictly prohibited, and you should be legally
  responsible for the unauthorized use or violation of confidentiality obligation.
-->
<!--
Program: Modal Container
Author: SDL
Description: Modal Container Common Component
-->
<template>
  <div id="modals-container">
    <modal
      v-for="modal in modals"
      :key="modal.id"
      v-bind="modal.modalAttrs"
      v-on="modal.modalListeners"
      @closed="remove(modal.id)"
    >
      <component
        :is="modal.component"
        v-bind="modal.componentAttrs"
        v-on="$listeners"
        @close="$modal.hide(modal.modalAttrs.name)"
      />
    </modal>
  </div>
</template>
<script>
import { generateId } from './utils';

const PREFIX = '_dynamic_modal_';

export default {
  name: 'ModalsContainer',
  data() {
    return {
      modals: [],
    };
  },
  created() {
    // eslint-disable-next-line no-underscore-dangle
    this.$root._dynamicContainer = this;
  },
  methods: {
    add(component, componentAttrs = {}, modalAttrs = {}, modalListeners = {}) {
      const id = generateId();
      const name = modalAttrs.name || PREFIX + id;

      this.modals.push({
        id,
        modalAttrs: { ...modalAttrs, name },
        modalListeners,
        component,
        componentAttrs,
      });

      this.$nextTick(() => {
        this.$modal.show(name);
      });
    },
    remove(id) {
      const index = this.modals.findIndex(v => v.id === id);

      if (index !== -1) {
        this.modals.splice(index, 1);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/control/modal/ModalsContainer.vue